<mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ 'EMPLOYEE_AND_POSITION_SEARCH.PLACEHOLDER' | translate }}</mat-label>
    <input matInput type="text" [formControl]="searchControl" autocomplete="off">
    <button *ngIf="searchControl.value" matSuffix mat-icon-button [attr.aria-label]="'GENERAL.DELETE' | translate" (click)="clearText()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-icon matSuffix>search</mat-icon>
</mat-form-field>

<ng-container *ngIf="items$ | async as items">
    <div class="message-panel">
        {{ searchMessage }}
    </div>

    <div class="scroll-panel height-medium">
        <app-dynamic-list-item [actionState]="actionState" [noEdit]="true" *ngFor="let item of items; index as i" [index]="i" [source]="item">
            <div slot="readonly">
                <div class="flex-horizontal mainitems">
                    <div class="field-index"></div>
                    <div class="field-text">
                        <div class="name"><strong [innerHtml]="highlightText(item.itemSource.byEmployeeName, searchValue)"></strong></div>
                        <div class="sub-text" [innerHtml]="highlightText(item.itemSource.position, searchValue)"></div>
                        <div class="sub-text"> 
                            <span [innerHtml]="highlightText(item.itemSource.email ?? item.itemSource.userName, searchValue) + ' '"></span>
                            <span [attr.title]="'EMPLOYEE_AND_POSITION_SEARCH.UNIQUE_EMPLOYEE_IDENTIFIER' | translate" [innerHtml]="highlightText(item.itemSource.employeeIdentifier, searchValue)"></span>
                        </div>
                        <div class="sub-text">{{ item.itemSource.closedOn | localizedDate }}</div>
                    </div>
                    <div class="field-buttons" *ngIf="!isExists(item.itemSource.reviewPeriodEmployeeId)">
                        <button mat-flat-button color="primary" (click)="addEmployee(item)">
                            <mat-icon class="normal no-margin" [attr.title]="'EMPLOYEE_AND_POSITION_SEARCH.SELECT_EMPLOYEE' | translate">add</mat-icon>
                        </button>
                    </div>
                </div>

            </div>
        </app-dynamic-list-item>
    </div>

    <mat-paginator #paginator [length]="total"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pagingSettingsChanged($event)"
                [attr.aria-label]="'GENERAL.CHOOSE_PAGE' | translate">
    </mat-paginator>
</ng-container>
